import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import { Box, FormHelperText, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { isValidPassword } from "../../consts/helpers";

export default function PasswordInput({ password, withConfirmation=false, confirmPassword, changeHandler, isPasswordMatchValid, setIsPasswordRegexValid }) {
    const [isValid, setIsValid] = useState({});

    useEffect(() => {
        let regexCheck = isValidPassword(password);
        setIsValid(regexCheck);
        setIsPasswordRegexValid(Object.values(regexCheck).every(v => v===true));
    },[password]);

    return (
        <>
        <Box>
            <FormHelperText>
                Password Requirements:
            </FormHelperText>
            <FormHelperText>
                <span className="centered-x">
                    <ConditionIndicator conditionIsMet={isValid?.minLen8} />&ensp;At least 8 characters long<br/>
                </span>
                <span className="centered-x">
                    <ConditionIndicator conditionIsMet={isValid?.hasUppercase} />&ensp;At least 1 uppercase letter<br/>
                </span>
                <span className="centered-x">
                    <ConditionIndicator conditionIsMet={isValid?.hasLowercase} />&ensp;At least 1 lowercase letter<br/>
                </span>
                <span className="centered-x">
                    <ConditionIndicator conditionIsMet={isValid?.hasDigit} />&ensp;At least 1 number<br/>
                </span>
                <span className="centered-x">
                    <ConditionIndicator conditionIsMet={isValid?.hasSpecialChar} />&ensp;At least 1 special character: ! @ # $ % & * ?
                </span>
            </FormHelperText>
        </Box>
        <TextField
            className='rounded-input' 
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={changeHandler}
            margin="normal"
            required
            error={!isValid?.validLen}
            helperText={!isValid?.validLen ? "This password is too long!" : ""}
        />
        {
            withConfirmation &&
            <TextField
                className='rounded-input' 
                fullWidth
                label="Confirm New Password"
                type="password"
                variant="outlined"
                value={confirmPassword}
                onChange={e => changeHandler(e, true)}
                margin="normal"
                required
                error={!isPasswordMatchValid && confirmPassword.length > 0}  
                helperText={!isPasswordMatchValid && confirmPassword.length > 0 ? "Passwords do not match." : ""} 
            />
        }
        </>
    )
}

const ConditionIndicator = ({conditionIsMet=false}) => {
    if (conditionIsMet) return <CheckCircle fontSize={'small'} color={'success'} />
    else return <RadioButtonUnchecked fontSize={'small'} />
}